module.exports = __webpack_public_path__ + "img/vendor_bg.ff48094a.png";